module.exports = __webpack_public_path__ + "img/ac.0aee9142.png";